import { Heart } from "lucide-react";
import { Link } from "react-router-dom";
import { Reveal } from "./Reveal";

export default function SupportSympTrack() {
  return (
    <section className="pb-20 md:pb-28" data-testid="support-section">
      <div className="symp-container">
        <Reveal>
          <div
            className="relative mx-auto max-w-[920px] overflow-hidden rounded-[40px] bg-brand-peach/50 px-8 py-12 text-center md:px-14 md:py-16"
            data-testid="support-panel"
          >
            <div
              aria-hidden="true"
              className="pointer-events-none absolute -right-16 -top-16 h-[200px] w-[200px] rounded-full bg-brand-aqua/60"
            />
            <div
              aria-hidden="true"
              className="pointer-events-none absolute -left-14 bottom-[-70px] h-[170px] w-[170px] rounded-full bg-brand-coral/15"
            />
            <div className="relative">
              <h2 className="section-title text-brand-teal">
                Support SympTrack
              </h2>
              <p className="mx-auto mt-4 max-w-[640px] text-[18px] font-medium leading-[1.6] text-brand-ink md:text-[20px]">
                Support helps SympTrack continue building, validating and
                moving the work forward. Every bit of support goes into the
                product, the people it is made for, and the mission behind it.
              </p>
              <a
                href="https://buy.stripe.com/4gM28kcYggoqb50gq7cIE00"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="support-symptrack-button"
                className="btn-coral primary-action mt-8 h-[64px] px-9 text-[18px]"
              >
                <Heart aria-hidden="true" className="h-5 w-5 fill-white" />
                Support SympTrack
              </a>
              <p className="mt-7 text-[15px] font-semibold text-brand-ink/80">
                Investment and partnership inquiries?{" "}
                <Link
                  to="/#contact"
                  className="underline underline-offset-4 hover:text-brand-teal"
                  data-testid="support-contact-link"
                >
                  Get in touch
                </Link>
                .
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
